
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BlogPostsList } from "@/components/blog/BlogPostsList";
import { Seo } from "@/components/Seo";

export default function Blog() {
  const location = useLocation();
  const [expandedPosts, setExpandedPosts] = useState<{[key: string]: boolean}>({
    post1: false,
    post2: false,
    post3: false,
    post4: false,
    post5: false,
    post6: false,
    post7: false,
    post8: false,
    post9: false
  });

  // Auto-expand post if hash is present in URL
  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash && expandedPosts.hasOwnProperty(hash)) {
      setExpandedPosts(prev => {
        const newState = Object.keys(prev).reduce((acc, key) => {
          acc[key] = key === hash;
          return acc;
        }, {} as {[key: string]: boolean});
        return newState;
      });
      
      // Scroll to the post after a short delay to ensure it's rendered
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location.hash]);

  const togglePost = (postId: string) => {
    setExpandedPosts(prev => {
      // Create a new object with all posts collapsed
      const newState = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {} as {[key: string]: boolean});
      
      // Then toggle only the clicked post
      newState[postId] = !prev[postId];
      return newState;
    });
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-[#FFFD4C] via-[#FFFD4C] to-[#F5E84A]">
      <Seo title="Blog | Enfants de la République" description="Articles, tribunes et publications de l'association Enfants de la République sur la citoyenneté et les valeurs républicaines." path="/blog" />
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8 pt-28">
        <h1 className="text-2xl sm:text-3xl font-bold text-[#1E3A8A] mb-6">Les posts</h1>
        <BlogPostsList expandedPosts={expandedPosts} togglePost={togglePost} />
      </main>
      <Footer />
    </div>
  );
}
